module.exports = __webpack_public_path__ + "img/navigation-prev.f4d5984c.svg";